export default "__VITE_ASSET__f5EMQscA__"